import React from "react";
import { FormBlock, PageContainer } from "../ui";
import EasyTrans from "../bundel/EasyTrans";

const RegisterWorkConfirmation = (props) => {
  return (
    <PageContainer>
      <div className="mt-10 sm:mt-0">
        <FormBlock
          title={<EasyTrans>RegisterWork.Confirmation.Title</EasyTrans>}
          description={<EasyTrans>RegisterWork.Confirmation.Caption</EasyTrans>}
        >
          <form action="#" method="POST" className="space-y-6">
            <fieldset>
              <div className="space-y-4">
                <div className="flex items-center">
                  <input
                    id="right"
                    name="right"
                    type="checkbox"
                    required={true}
                    className={`focus:ring-fairblue-500 h-4 w-4 text-fairblue-500 border-gray-300 ${
                      props.confirmationError
                        ? "border-2 border-red-700 bg-red-50"
                        : ""
                    }`}
                    onChange={(event) => {
                      props.onSetConfirmation(event.target.checked);
                      props.setConfirmationError(false);
                    }}
                  />
                  <label className="ml-3 block text-sm font-medium text-gray-700">
                    <EasyTrans>RegisterWork.Confirmation.Text</EasyTrans>
                    <span className="text-red-600">*</span>
                  </label>
                </div>
                {props.confirmationError && (
                  <span className="mt-2 block text-sm text-red-700">
                    <EasyTrans>
                      RegisterWork.Confirmation.Confirmation
                    </EasyTrans>
                  </span>
                )}
              </div>
            </fieldset>
          </form>
        </FormBlock>
      </div>
      <div className="hidden sm:block" aria-hidden="true">
        <div className="py-5">
          <div className="border-t border-gray-200" />
        </div>
      </div>
    </PageContainer>
  );
};

export default RegisterWorkConfirmation;
